// Lightweight analytics client for sending interaction events to backend
// Privacy-preserving: minimal payload, no identifiers.

export type AnalyticsMeta = Record<string, unknown> | undefined;

export async function sendAnalyticsEvent(type: string, meta?: AnalyticsMeta) {
  try {
    const payload = {
      type,
      path: typeof window !== 'undefined' ? window.location.pathname : undefined,
      meta,
    };
    await fetch('/api/analytics/event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      // Do not send credentials; keep it simple and privacy-friendly
      credentials: 'omit',
    });
  } catch (err) {
    // Swallow errors to avoid impacting UX; optionally log in dev
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.debug('analytics send failed', err);
    }
  }
}
